import React, { useState, useEffect } from "react";
import {
  Line,
  Area,
  Column,
  LineConfig,
  AreaConfig,
  ColumnConfig,
  Plot,
  PlotEvent,
  Bar,
} from "@ant-design/charts";
import { Row, Typography } from "antd";
import moment from "moment-jalaali";

const { Text } = Typography;
function BarPlots(props) {
  const [data, setData] = useState([]);

  useEffect(() => {
    // asyncFetch();
    setData(props.data);
  }, [props]);

  const config = {
    data,
    xField: props.xaxis,
    yField: props.yaxis,
    isStack: props.stacked,
    seriesField: props.stackFeild,
    color: props.color,
    height: 320,
    legend: { position: "top-right" },
  };

  return (
    <Row
      style={{
        // marginTop: "24px",
      }}
    >
      <Column {...config} />
    </Row>
  );
}

export default BarPlots;
